import { formSchemas } from '@components/form';
import { z } from 'zod';

export const profileSchema = z
  .object({
    display_name: formSchemas.userSchema.nameSchema,
    email: formSchemas.directoryScheme.emailSchema,
  })
  .required();

const passwordPolicySchema = z
  .string()
  .min(8, { message: 'Password must be at least 8 characters' })
  .max(100, { message: 'Password must be less than 100 characters' })
  .regex(/^\S*$/, {
    message: 'Password must not have spaces',
  })
  .regex(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])\S{8,100}$/,
    {
      message:
        'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character',
    },
  );

export const changePasswordSchema = z
  .object({
    current_password: z
      .string()
      .min(1, { message: 'Current password is required' }),
    password: passwordPolicySchema,
    confirmPassword: z
      .string()
      .min(1, { message: 'Please confirm your new password' }),
  })
  .refine((values) => values.password === values.confirmPassword, {
    message: 'Passwords must match',
    path: ['confirmPassword'],
  });

export type ProfileFormValues = z.infer<typeof profileSchema>;
export type ChangePasswordFormValues = z.infer<typeof changePasswordSchema>;
